import { Change, ChangeTypes } from "../FirebaseClient/types";
import { store } from "../../redux";

export function selectChange<T extends keyof ChangeTypes>(changeName: T): Change<T> | undefined {
    const configuration = store.getState().configuration;
    if (!configuration.currentConfigurationId) {
        // hide this log in tests to not spam the log so much
        if (!process.env.JEST_WORKER_ID) {
            console.warn("no current configuration id set, call 'load' before selecting a change");
        }
        return;
    }
    const change =
        configuration.configurations[configuration.currentConfigurationId].state[changeName];

    // if (!change) throw `no change with name ${changeName}`;

    return change as Change<T>;
}
